import SplitInfoCard from '@rsa-digital/evo-shared-components/components/SplitInfoCard/SplitInfoCard';
import React from 'react';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { nonFatalBuildError } from 'helpers/errorReporting';
import { SplitInfoCardBlockProps } from '../types';

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
const isNotPreview = activeEnv !== 'preview';

const SplitInfoCardBlock: React.FC<SplitInfoCardBlockProps> = ({ split_info_card }) => {
  const icon = unwrapSingleton(split_info_card.icon);
  const globalPhoneNumber = unwrapSingleton(split_info_card.global_phone_number);
  /* istanbul ignore if */
  if (!icon) {
    if (isNotPreview) {
      throw new Error('Icon for Split Info Card missing!');
    }
    nonFatalBuildError(
      'Icon for Split Info Card missing!',
      'Split Info Cards require an icon to be displayed.'
    );
    return <></>;
  }

  const phoneNumber = globalPhoneNumber?.telephone_number ?? split_info_card.phone_number;
  const bodyText = split_info_card.html_body ?? split_info_card.body;

  return (
    <SplitInfoCard
      data-cy="Split Info Card"
      icon={icon.icon_code}
      heading={split_info_card.heading}
      body={bodyText || ''}
      phoneNumber={phoneNumber}
      phoneNumberAria={globalPhoneNumber?.screen_reader_text}
      openingHours={split_info_card.opening_hours}
      openPhoneInNewTab={globalPhoneNumber?.open_in_new_tab}
    />
  );
};

export default React.memo(SplitInfoCardBlock);
